import { render, staticRenderFns } from "./PageXxz.vue?vue&type=template&id=4d3ae9f3&scoped=true&"
import script from "./PageXxz.vue?vue&type=script&lang=js&"
export * from "./PageXxz.vue?vue&type=script&lang=js&"
import style0 from "./PageXxz.vue?vue&type=style&index=0&id=4d3ae9f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3ae9f3",
  null
  
)

export default component.exports